import React, { Fragment } from 'react';

const WhatisAutzuEV = () => (
  <Fragment>
    <p>
      Autzu EV is our tier of zero-emission electric vehicles, starting at
      $7 per hour. Autzu EV vehicles allow you to accept various
      ridesharing trip requests, including:
    </p>
    <ul>
      <li>Standard (UberX, UberX Share, Uber Pet)</li>
      <li>Premium (Comfort, Premier)</li>
      <li>Green (Uber Green, Comfort Electric)</li>
      <li>Other (Pet, Connect)</li>
      <li>Food Delivery (Uber Eats)</li>
    </ul>
    <br />
    <p>
      When driving Autzu EV, you will be able to opt-in to Uber’s Zero
      Emission Incentive program.
    </p>
    <p>The Zero Emissions incentive has 2 perk opportunities:</p>

    <ul>
      <li>
        Get an extra $1 on every rideshare trip made in an EV (up to $5,000
        over a 12-month period)
      </li>
      <li>
        After your first 1,000 trips in an EV over a 3-month Uber Pro
        Program Period, get an extra $250. You can get this extra benefit
        once during each period, which can add up to an additional $1,000
        per year.¹
      </li>
    </ul>

    <p>
      This incentive's 12-month period is February 1, 2024, to January 31,
      2025.
    </p>
  </Fragment>
);

export default WhatisAutzuEV;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/General/WhatIsAutzuEV.js